var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-content"}},[_c('p',[_vm._v(" You’ve been inactive for quite a while. If you wish to stay logged in please choose \"Stay Logged In\", otherwise you will be logged out in "+_vm._s(_vm.time)+" sec... ")])])}
var staticRenderFns = []

export { render, staticRenderFns }